let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("17Hoi")).then(() => parcelRequire('5GBzn'));